"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconVolume = function IconVolume(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "20",
    height: "16",
    className: (0, _classnames.default)('Icon', 'IconVolume', className),
    style: style
  }, _react.default.createElement("path", {
    d: "M10.43.082a1 1 0 00-1 .12l-4.78 3.78H1a1 1 0 00-1 1v6a1 1 0 001 1h3.65l4.73 3.78a1 1 0 00.62.22.912.912 0 00.43-.1 1 1 0 00.57-.9v-14a1 1 0 00-.57-.9zM9 12.902l-3.38-2.7a1 1 0 00-.62-.22H2v-4h3a1 1 0 00.62-.22L9 3.062v9.84zm8.66-10.58a1.004 1.004 0 00-1.42 1.42 6 6 0 01-.38 8.84 1 1 0 00.64 1.76 1 1 0 00.64-.23 8 8 0 00.52-11.79zm-2.83 2.83a1.004 1.004 0 00-1.42 1.42 2 2 0 01.59 1.41 2 2 0 01-.71 1.53 1 1 0 00-.13 1.41 1 1 0 001.41.12A4 4 0 0016 7.982a4.06 4.06 0 00-1.17-2.83z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

var _default = IconVolume;
exports.default = _default;